import "./landing.css";
import React from "react";
import { Link } from "@reach/router";

import { Button, Typography } from "antd";

const { Paragraph } = Typography;

const Callout = () => (
  <Paragraph type="secondary" className="callout__text">
    Amplifique a diferença entre cores em vídeo para auxiliar na sua distinção
    por portadores de daltonismo, ou faça o teste para descobrir se possui esta
    condição
  </Paragraph>
);

export default () => {
  return (
    <div className="callout">
      <div>
        <h1 className="callout__title">Color Blind App</h1>
        <Callout />
        <div className="callout__btns">
          <a href="/camera">
            <Button icon="camera" type="primary">
              Use a camera
            </Button>
          </a>
          <a href="/quiz">
            <Button icon="form">Faça o teste</Button>
          </a>
          <a href="/sobre">
            <Button icon="info-circle"></Button>
          </a>
        </div>
      </div>
      <img
        className="callout__img"
        alt="Floating girl illustration"
        src="/float.svg"
      />
    </div>
  );
};
